import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register PWA service worker and auto-reload on new version available.
// Strategy:
//  1. Register /sw.js
//  2. On every app open, call reg.update() to bypass SW script caching
//  3. When a new SW becomes "installed" while an old controller is still active,
//     send skipWaiting() and reload once the new SW takes control.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Force check for sw.js update whenever the app opens / gains focus
      reg.update().catch(() => { /* offline or network issue — fine */ });
      window.addEventListener('focus', () => {
        reg.update().catch(() => {});
      });

      // A new SW has been found and is installing
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          // "installed" + existing controller ⇒ update ready, activate + reload
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            newWorker.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
    }).catch((err) => {
      console.log('SW registration failed:', err);
    });

    // When the new SW takes control, reload the page so the user gets fresh bundle.
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
